const PUBLIC_CURRENCY_FORMATTER = new Intl.NumberFormat('en-CA', {
  style: 'currency',
  currency: 'CAD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatPublicCurrency(value: number): string {
  return PUBLIC_CURRENCY_FORMATTER.format(value);
}
